import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { colors } from 'bench-style-constants';

import HistoryDateRange from './HistoryDateRange';
import BkNameContainer from './BkNameContainer';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, auto) 1fr;
  padding: 12px 0;
`;

const ReviewCard = styled.div`
  border: 1px solid ${colors.silt};
  border-radius: 5px;
  overflow: hidden;
`;

const ReviewNotes = styled.div`
  padding: 12px;
  background: ${colors.pearl};
  color: ${colors.charcoal};
  border-bottom: 1px solid ${colors.silt};
  font-size: 14px;
  white-space: pre-wrap;
`;

const ReviewDetails = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  padding: 12px;
  color: ${colors.charcoal};
  font-size: 12px;
`;

const Reviewer = styled.span`
  font-weight: bold;
`;

const ReviewStatus = styled.div<{ status: string }>`
  justify-self: flex-end;
  color: ${({ status }) => {
    switch (status) {
      case 'REVIEWED_WITH_OUTSTANDING':
        return colors.copper;
      case 'COMPLETE':
        return colors.bonsai;
      case 'REVISION_REQUIRED':
      case 'INCOMPLETE':
        return colors.copper;
      default:
        return colors.charcoal;
    }
  }};
`;

type HistoryReviewProps = {
  notes: string;
  status: string;
  fromDate: string;
  toDate: string;
  submittedAt: number;
  submitterId: string;
  hideDate: boolean;
};

export const HistoryReview = ({
  notes,
  status,
  fromDate,
  toDate,
  submittedAt,
  submitterId,
  hideDate,
}: HistoryReviewProps) => (
  <Wrapper>
    {hideDate ? <div /> : <HistoryDateRange fromDate={fromDate} toDate={toDate} />}
    <ReviewCard>
      {notes && <ReviewNotes>{notes}</ReviewNotes>}
      <ReviewDetails>
        Reviewed by&nbsp;
        <Reviewer>
          <BkNameContainer id={submitterId} />
        </Reviewer>
        ,&nbsp;
        {moment.unix(submittedAt).format('MMM Do, YYYY')}
        <ReviewStatus status={status}>{status.replace(/_/g, ' ')}</ReviewStatus>
      </ReviewDetails>
    </ReviewCard>
  </Wrapper>
);

HistoryReview.defaultProps = {
  hideDate: false,
};

export default HistoryReview;
